/**
 * Cancellation survey categories (GDN-2986).
 *
 * The paying-cancel dialog presents these nine options as a required
 * multi-select. IDs are the contract with the server — they must match the
 * `CancelReasonCategory` enum in
 * `smartscribe-server` (control_plane/subscriptions provider schemas). The
 * server maps the primary (first-selected) category onto Stripe's native
 * `feedback` enum and writes the full selection as JSON into
 * `cancellation_details.comment`.
 */

export const CANCEL_REASON_CATEGORIES = [
  { id: 'too_expensive', label: 'Too expensive' },
  { id: 'missing_features', label: 'Missing features I need' },
  { id: 'switched_service', label: 'Switched to a different product' },
  { id: 'not_using', label: 'Not using it enough' },
  { id: 'too_complex', label: 'Too difficult to use' },
  { id: 'low_quality', label: "Quality didn't meet my expectations" },
  { id: 'customer_support', label: 'Unhappy with customer support' },
  { id: 'temporary_need', label: 'Only needed it temporarily' },
  { id: 'other', label: 'Other' },
] as const;

export type CancelReasonCategoryId = (typeof CANCEL_REASON_CATEGORIES)[number]['id'];
